import { themeObject } from '../../lib';

export const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100% - 5px)',
        overFlowY: 'hidden',
    },
    cardContainer: {
        display: 'flex',
        height: 'calc(100vh - 170px)',
        borderRadius: '10px',
        border: `1px solid ${themeObject.palette.grayScale[200]}`,
        mt: '29px',
        mb: 4.5,
        overFlowY: 'hidden',
    },
    insufficientPermissionsImage: {
        marginTop: '-45px',
    },
    notFoundImage: {
        marginTop: 0,
    },
};
